<ng-container *ngIf="!loading">

  <ng-container *ngIf="!error">
    <div class="header">
      <div><ng-content select="[header]"></ng-content></div>
      <span *ngIf="closable" (click)="hide()">×</span>
    </div>
    <div class="body">
      <ng-content></ng-content>
    </div>
  </ng-container>

  <connection-error *ngIf="error" (retry)="reload()"></connection-error>

</ng-container>

<ngx-loading [show]="loading || lock" [config]="{backdropBackgroundColour: lock ? '#00000022' : 'transparent' }"></ngx-loading>
